import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ClipboardList, ChevronDown, ChevronUp } from "lucide-react";

const LABEL = {
  SEM_QUADRO: ["Sem quadro", "bg-red-600"],
  SEM_PROFESSOR: ["Tempos sem professor", "bg-amber-500"],
  INCOMPLETO: ["Tempos vazios", "bg-slate-500"],
  OK: ["Completo", "bg-emerald-600"],
};

export function SchedulePending({ schoolId, refreshKey, onPick }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    api.get("/schedule/status", { params: { school_id: schoolId || undefined } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [schoolId, refreshKey]);
  if (!data) return null;
  const pending = data.classes.filter((c) => c.status === "SEM_QUADRO" || c.status === "SEM_PROFESSOR");
  return (
    <Card className="mb-4 min-w-0 p-4" data-testid="schedule-pending-card">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between gap-2 text-left" data-testid="schedule-pending-toggle">
        <div className="flex flex-wrap items-center gap-2">
          <ClipboardList className="h-5 w-5 text-orange-500" />
          <span className="font-semibold text-slate-900">Pendências do quadro</span>
          <Badge className="bg-red-600" data-testid="pending-no-schedule-count">{data.summary.SEM_QUADRO} sem quadro</Badge>
          <Badge className="bg-amber-500" data-testid="pending-no-teacher-count">{data.summary.SEM_PROFESSOR} com tempos sem professor ({data.code})</Badge>
        </div>
        {open ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
      </button>
      {open && (
        pending.length === 0
          ? <p className="mt-3 text-sm text-emerald-700" data-testid="pending-none">Todas as turmas têm quadro e todos os tempos têm professor.</p>
          : (
            <div className="mt-3 grid min-w-0 grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3" data-testid="pending-list">
              {pending.map((c) => (
                <button key={c.class_id} type="button" onClick={() => onPick(c.class_id)} data-testid={`pending-class-${c.class_id}`}
                  className="rounded-lg border border-slate-200 p-3 text-left transition-colors hover:border-orange-300 hover:bg-orange-50">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-slate-900">Turma {c.class_name}</span>
                    <Badge className={LABEL[c.status][1]}>{LABEL[c.status][0]}</Badge>
                  </div>
                  <div className="text-xs text-slate-500">{c.shift}{c.total ? ` • ${c.filled}/${c.total} tempos preenchidos` : ""}</div>
                  {c.no_teacher.length > 0 && (
                    <div className="mt-1 text-xs text-amber-800">
                      {c.no_teacher.length} tempo(s) sem professor: {c.no_teacher.slice(0, 4).map((t) => `${t.day} ${t.period}º${t.subject_name ? ` (${t.subject_name})` : ""}`).join(", ")}{c.no_teacher.length > 4 ? "…" : ""}
                    </div>
                  )}
                </button>
              ))}
            </div>
          )
      )}
    </Card>
  );
}
